module.exports = __webpack_public_path__ + "static/section-img4@2x-75bf11b58ace1fcc4136dcf175a442b3.png";